import { combineReducers } from 'redux'
import modal from './modal'
import user from './user'
import products from './products'
import blogs from './blogs'
import comments from './comments'
import contact from './contact'
import orders from './orders'
const rootReducer = combineReducers({
    modal,
    user,
    products,
    blogs,
    comments,
    contact,
    orders
})

export default rootReducer